import React from "react";
import { Hyperlink, HyperlinkProps } from "../../../../Links/Hyperlink/Hyperlink";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { Text, TextProps } from "../../../../Text/Text";
import { TruncatedText, TruncatedTextProps } from "../../../../TruncatedText/TruncatedText";
import { ListItemColumnProps } from "../../shared/props";

export interface HyperlinkTitleColumnProps extends ListItemColumnProps {
    /**
     * HyperlinkProps props to create the title hyperlink element.
     */
    readonly titleHyperlinkProps: HyperlinkProps;

    /**
     * Array of string subtitles to create text elements below the title.
     */
    readonly subtitles?: readonly TextProps[];

    /**
     * Configuration to render ellipsis for long subtitle text
     */
    readonly truncatedSubtitleTextProps?: Pick<TruncatedTextProps, "lines" | "stopPropagation">;
}

export const HyperlinkTitleColumn: React.FC<HyperlinkTitleColumnProps> = ({
    titleHyperlinkProps,
    subtitles = [],
    disabled,
    truncatedSubtitleTextProps
}) => {
    return (
        <Stack>
            <Hyperlink {...titleHyperlinkProps} />
            {subtitles.map((subtitle, index) =>
                truncatedSubtitleTextProps ? (
                    <TruncatedText
                        lines={truncatedSubtitleTextProps.lines}
                        stopPropagation={false}
                        {...subtitle}
                        disabled={disabled}
                        key={index}
                    />
                ) :
                <Text {...subtitle} disabled={disabled} key={index} />
            )}
        </Stack>
    );
};
